module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.c1d289e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_lets-get_768.png
// module id = Mnku
// module chunks = 0